export enum DISPLAY_FORMAT {
  HORIZONTAL = 'horizontal_list',
  VERTICAL = 'vertical_list',
  GRID = 'grid',
  DETAIL = 'product_detail_page',
  SHELF = 'shelf',
  ANIMATION = 'animation',
  IMAGE = 'image',
  ORIGINAL_PRODUCT = 'original_product',
  BENTO_PROMO_GRID = '3-up grid',
  BENTO_COMPACT = 'bento_compact',
  BENTO_VERTICAL = 'bento_vertical',
  BENTO_HORIZONTAL = 'bento_horizontal',
  STORE_BUTTON = 'store_button',
  PDP_MEMBERSHIP_BANNER = 'membership_banner',
  CART_BUILDER = 'cart_builder',
}

export const REDIRECT_URL_SESSION_KEY = 'segway_redirect_url'
